<palantir-dialog [title]="'TAB_MAINTENANCE_PRODUCTS.DIALOG.TITLE' | translate">
  <palantir-dialog-content class="p-0">
    <palantir-input class="mt-6 mx-6" [control]="searchControl" prefix="search-outline">
      <input type="text" [placeholder]="'TAB_MAINTENANCE_PRODUCTS.DIALOG.SEARCH' | translate" [formControl]="searchControl" />
    </palantir-input>

    @if (!productsTabService.isLoading() && !products().length) {
      <palantir-text type="description" size="xs" class="mx-6 mt-2">
        {{ 'TAB_MAINTENANCE_PRODUCTS.DIALOG.EMPTY' | translate }}
      </palantir-text>
    }

    <ng-scrollbar class="w-full flex flex-col max-h-[300px]" [visibility]="'hover'" [autoHeightDisabled]="false">
      <div class="flex flex-col gap-2 p-6 pt-1">
        @if (productsTabService.isLoading()) {
          <palantir-skeleton class="w-full h-12 rounded-lg"></palantir-skeleton>
          <palantir-skeleton class="w-full h-12 rounded-lg"></palantir-skeleton>
          <palantir-skeleton class="w-full h-12 rounded-lg"></palantir-skeleton>
        } @else {
          @for (product of products(); track product.id) {
            <palantir-list-item [attr.aria-selected]="isSelected(product.id)" (click)="toggleItem(product)" style="cursor: pointer">
              <palantir-list-item-prefix>
                <palantir-icon name="package-outline"></palantir-icon>
              </palantir-list-item-prefix>
              <palantir-list-item-content>
                <palantir-text type="title" [truncate]="true">{{ product.name }}</palantir-text>
              </palantir-list-item-content>
              <palantir-list-item-suffix>
                <input
                  type="checkbox"
                  class="accent-color-primary"
                  [checked]="isSelected(product.id)"
                  (click)="$event.stopPropagation(); toggleItem(product)"
                />
              </palantir-list-item-suffix>
            </palantir-list-item>
          }
        }
      </div>
    </ng-scrollbar>
  </palantir-dialog-content>

  <palantir-dialog-actions>
    <palantir-button theme="outline" (click)="close()">
      {{ 'TAB_MAINTENANCE_PRODUCTS.DIALOG.BUTTONS.CANCEL' | translate }}
    </palantir-button>
    <palantir-button (click)="save()" [disabled]="!selectedItems().length">
      {{ 'TAB_MAINTENANCE_PRODUCTS.DIALOG.BUTTONS.SAVE' | translate }}
    </palantir-button>
  </palantir-dialog-actions>
</palantir-dialog>
